import { memo } from "react";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import { AccordionOnlyUseBasic } from "@/components/features/items/edit/_shared/ui/components/system/accordion/only-use-basic/accordion";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

import { usePlanIsRoomPriceFree } from "./hooks";

export const QuestionPlanIsRoomPriceFree = memo(() => {
	const { activate, deactivate, isRoomPriceFree, hotelID } = usePlanIsRoomPriceFree();

	const label = "部屋の料金を無料にする";
	const guide =
		"このプランで選択される部屋の料金を無料に設定することができます。<br />部屋の料金を取らずに販売したい場合に選択してください。<br />サイトコントローラーの仕様上、部屋を販売するためには部屋の料金を1円以上で流し込んでおく必要があります。<br />流し込まれた部屋の料金が0円の場合は、売り止めになります。一方、部屋の料金がいくらであっても、このプランを介した予約の場合は部屋料金が無料で販売されます。";

	const checkBoxLabel = "このプランを選択した場合に部屋の料金が無料になるようにする";
	const handleIsRoomPriceFreeInput = (input: boolean) => {
		if (input) {
			activate(input);
		} else {
			deactivate(input);
		}
	};

	return (
		<AccordionOnlyUseBasic
			hotelID={hotelID}
			defaultOpen={isRoomPriceFree.isEdited}
			accordionTitle="このプランの部屋料金を無料にする"
		>
			<FeatureIslandCategoryQuestionForMain
				required={false}
				title={label}
				guide={guide}
				isEdited={isRoomPriceFree.isEdited}
				hasError={Boolean(isRoomPriceFree.error)}
				inputChildren={
					<CheckboxField
						value={isRoomPriceFree.value}
						label={checkBoxLabel}
						handleChange={handleIsRoomPriceFreeInput}
						errorMessage={isRoomPriceFree.error}
					/>
				}
			/>
		</AccordionOnlyUseBasic>
	);
});

QuestionPlanIsRoomPriceFree.displayName = "QuestionPlanIsRoomPriceFree";
